import { CreatedByTypes, UserTypes } from '../enums/user.type';

export const determineCreatedByValue = (userType: string, selectedAccountType: string) => {
  let createdBy = CreatedByTypes.SELF;

  if (userType === UserTypes.CHILD) {
    createdBy = CreatedByTypes.ADULT;
  } else if (userType === UserTypes.STUDENT && selectedAccountType === 'educator') {
    createdBy = CreatedByTypes.EDUCATOR;
  }

  return createdBy;
};
